import { useQuery } from '@tanstack/react-query';
import type { FormatKind } from '@signalvote/shared';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';

// FIN-011 — GET /api/finance/formats?stateCode=XX returns the registered
// `FormatKind[]` for a state. Empty array means no builder is registered
// yet (e.g. AL pre-FIN-009). Used by the filings format picker, which is
// omitted from the DOM when length <= 1.

export function useFinanceFormats(stateCode: string | null) {
  return useQuery({
    queryKey: queryKeys.finance.formats(stateCode),
    queryFn: () =>
      apiJson<FormatKind[]>(`/api/finance/formats?stateCode=${encodeURIComponent(stateCode ?? '')}`, {
        error: 'Failed to fetch supported formats',
      }),
    enabled: authService.isAuthenticated() && !!stateCode,
    staleTime: 60_000,
  });
}
